type NotificationType = 'success' | 'warning' | 'error';

interface StatusContext {
  successMessage?: string;
  noContentMessage?: string;
  errorMessage?: string;
  defaultMessage?: string;
}

type StatusData = {
  message: string;
  status: number;
  notificationType: NotificationType;
  isSuccess: boolean;
  isError: boolean;
  isWarning: boolean;
};

export const handleStatusCode = (
  statusCode: number,
  context: StatusContext = {}
): StatusData => {
  let notificationType: NotificationType = 'error';
  let message = context.defaultMessage || 'Unexpected server response.';
  let isSuccess = false;
  let isError = false;
  let isWarning = false;

  if (statusCode >= 200 && statusCode < 300 && statusCode !== 204) {
    notificationType = 'success';
    message = context.successMessage || 'Operation completed successfully.';
    isSuccess = true;
  } else if (statusCode === 204) {
    notificationType = 'warning';
    message = context.noContentMessage || 'No content available.';
    isWarning = true;
  } else if (statusCode >= 400 && statusCode < 500) {
    notificationType = 'error';
    message = context.errorMessage || 'There was an error. Please try again.';
    isError = true;
  } else if (statusCode === 500) {
    notificationType = 'error';
    message = context.errorMessage || 'There was an error. Please try again.';
    isError = true;
  } else {
    // unexpected status
    isError = true;
  }

  return {
    message,
    status: statusCode,
    notificationType,
    isSuccess,
    isError,
    isWarning,
  };
};
